import React, { useState, useEffect } from 'react';
import CommonComponent from "../../CommonComponent"
import { useTranslation } from 'react-i18next';
import { productsTableData } from '../../Common/Datatable';
import DataTableLayout from '../../../../utility/table/DataTableLayout.jsx'

const Products = ()=> {
  const { tableId, ajaxUrl, columns } = productsTableData;
  const { t } = useTranslation();

  return (
    <>
      <CommonComponent />
      <section className="section dashboard py-2">
        <div className="row m-0">
          <div className="col-lg-12">
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <div className="filter"></div>
                  <div className="card-body h-auto">
                    <DataTableLayout tableId={tableId} ajaxUrl={ajaxUrl} columns={columns} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}


export default Products;